import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Duration } from '../../../components/FlightDetails/Duration.js';
import { Container } from '../../../components/FlightDetails/InfoBox/components/Container.js';
import { LabelXSmall, LabelXSmallBold, Stack } from '../../../primitives/index.js';
export const InfoBox = ({
  stayTime,
  changedNextFlightDate,
  children
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  return _jsxs(Container, {
    children: [_jsxs(Stack, {
      direction: "row",
      spacing: "small",
      children: [stayTime && _jsx(Duration, {
        children: stayTime
      }), _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: children
      })]
    }), changedNextFlightDate && _jsxs(Stack, {
      direction: "row",
      spacing: "small",
      children: [_jsx(LabelXSmall, {
        color: "contentSecondary",
        children: t('stay')
      }), _jsx(LabelXSmallBold, {
        color: "contentSecondary",
        children: t('longNight')
      })]
    })]
  });
};